/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import { css } from '@emotion/react';

interface IProps {
  children?: React.ReactNode;
  design: {
    // shape
    left?: string;
    top?: string;
    bottom?: string;
    width?: string; // e.g: 10px
    padding?: string; // e.g: 10px 10px 10px 10px
    margin?: string; // e.g: 10px 10px 10px 10px

    // align
    align?: 'up' | 'center' | 'down' | 'between' | 'around';

    // background
    backgroundColor?: string;
  };
}

const Wrapper = styled.div<Pick<IProps, 'design'>>`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;

  z-index: 1;
  flex-direction: column;
  position: fixed;
  left: ${(props) => props.design.left || '0px'};
  top: ${(props) => props.design.top || '0px'};
  bottom: ${(props) => props.design.bottom || '0px'};
  width: ${(props) => props.design.width || 'auto'};
  // TODO: padding 정리하기
  padding: ${(props) => props.design.padding || '0px'};
  padding-top: var(--sat);
  padding-bottom: var(--sab);
  margin: ${(props) => props.design.margin || '0px'};
  background-color: ${(props) => props.design.backgroundColor || 'transparent'};

  ${(props) =>
    props.design.align &&
    css`
      justify-content: ${props.design.align === 'up'
        ? 'flex-start'
        : props.design.align === 'down'
          ? 'flex-end'
          : props.design.align === 'between'
            ? 'space-between'
            : props.design.align === 'around'
              ? 'space-around'
              : 'center'};
    `}
`;

const SideContainer: React.FC<IProps> = ({ children, design }) => {
  return <Wrapper design={design}>{children}</Wrapper>;
};

export default SideContainer;
